import { render, staticRenderFns } from "./UseAdvices.vue?vue&type=template&id=7b096e5c"
import script from "./UseAdvices.vue?vue&type=script&lang=js"
export * from "./UseAdvices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports